module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-44.2365f1a7.png";